import { Modal } from "antd";

const useAlert = () => {
  const showAlert = ({ status = "danger", ...props }) => {
    Modal.confirm({
      icon: null,
      okButtonProps: {
        danger: status === "danger",
        style: {
          backgroundColor: status === "warning" ? "#FFDC7A" : undefined,
          color: status === "warning" ? "#252525" : undefined,
        },
      },
      width: 500,
      ...props,
    });
  };

  return {
    showAlert,
  };
};

export default useAlert;
